import { render, staticRenderFns } from "./webrtc_secure2_player.vue?vue&type=template&id=52645025"
import script from "./webrtc_secure2_player.vue?vue&type=script&lang=js"
export * from "./webrtc_secure2_player.vue?vue&type=script&lang=js"
import style0 from "./webrtc_secure2_player.vue?vue&type=style&index=0&id=52645025&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports